import { useCallback } from 'react'
import { useSnackbar } from 'notistack'
import { logger } from 'src/utils/logger'

const COPY_FAILED_MESSAGE = 'Unable to copy to the clipboard'

/**
 * Copies a value and confirms it with a snackbar: `copiedMessage` on success, a generic error when
 * the Clipboard API is missing (non-secure context) or the write is refused.
 */
export const useCopyToClipboard = () => {
  const snackbar = useSnackbar()

  return useCallback(
    async (value: string, copiedMessage: string): Promise<void> => {
      if (!navigator.clipboard) {
        snackbar?.enqueueSnackbar(COPY_FAILED_MESSAGE, { variant: 'error' })

        return
      }

      try {
        await navigator.clipboard.writeText(value)
        snackbar?.enqueueSnackbar(copiedMessage, { variant: 'success' })
      } catch (error: unknown) {
        logger.error('Failed to copy a value to the clipboard', error)
        snackbar?.enqueueSnackbar(COPY_FAILED_MESSAGE, { variant: 'error' })
      }
    },
    [snackbar],
  )
}
